import { layout } from '../../App.routing'

export const appDownloadSegment = layout.component({
    type: 'tn-app-download-card',
    props: {},
})
